import { useTranslation, Trans } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps, Text } from '@frontend/design-system';

type Props = ModalControlModalProps & {
  cancelDeleteList: () => void;
  finishDeleteList: () => Promise<void>;
  listName?: string;
};

export const DeleteListModal = ({ cancelDeleteList, finishDeleteList, listName, ...modalProps }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  return (
    <ConfirmationModal
      {...modalProps}
      destructive
      modalCss={{ minWidth: 600 }}
      onCancel={cancelDeleteList}
      onClose={cancelDeleteList}
      onConfirm={finishDeleteList}
      title={t('Are You Sure?')}
    >
      <Text>
        {listName ? (
          <Trans t={t}>
            Are you sure you want to delete <strong>{listName}</strong>?
          </Trans>
        ) : (
          t('Are you sure you want to delete this list?')
        )}
      </Text>
    </ConfirmationModal>
  );
};
